import React from "react";
import RitLogo from "./rit.png";
import GoogleLogo from "./google.png";
import "./login.css";

interface LoginComponentProps {
    onRitLogin?: () => void;
    onGoogleLogin?: () => void;
}

export default function LoginComponent({
                                           onRitLogin,
                                           onGoogleLogin,
                                       }: LoginComponentProps) {
    return (
        <div className="login-root">
            <div className="login-card">
                <h1 className="login-title">Sign in</h1>
                <p className="login-subtitle">
                    Choose how you’d like to authenticate.
                </p>

                <div className="login-buttons">
                    <button
                        type="button"
                        className="login-button login-button--rit"
                        onClick={onRitLogin}
                    >
                        <img
                            src={RitLogo}
                            alt="RIT Login"
                            className="login-button__icon"
                        />
                        <span className="login-button__label">
                            RIT Login
                        </span>
                    </button>

                    <button
                        type="button"
                        className="login-button login-button--google"
                        onClick={onGoogleLogin}
                    >
                        <img
                            src={GoogleLogo}
                            alt="Google logo"
                            className="login-button__icon"
                        />
                        <span className="login-button__label">
                            Log in with Google
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}
